export const DEFAULT_STYLE_VALUES = {
  font: "Open Sans",
  fontSize: 12,
  fontWeight: "normal",
  color: "#000000",
  position: "left",
  show: true
};

export const STYLE_ATTRIBUTE_EN_MAP = {
  "Color de Pleca": "pleca",
  "Título sobre la Pleca": "title",
  "Título de la nota": "subtitle",
  "Sintesis": "content",
  "Imagen": "image",
  "Título de Imagen": "imageTitle",
  "Testigos": "witnesses",
  "Linea Divisora": "dividerLine",
  "Grafico": "barChart",
  "Porcentaje": "percentage",
  "Valoracion": "valuation",
  "Costo": "cost",
  "Alcance": "scope",
};

export const STYLE_ATTRIBUTES = [
  { id: "pleca", label: "Color de Pleca" },
  { id: "title", label: "Título sobre la Pleca" },
  { id: "subtitle", label: "Título de la nota" },
  { id: "content", label: "Síntesis" },
  { id: "witnesses", label: "Testigos" },
  { id: "image", label: "Imagen" },
  { id: "imageTitle", label: "Título de Imagen" },
  { id: "dividerLine", label: "Línea Divisoria" },
  { id: "barChart", label: "Gráfico de Barras" },
  { id: "percentage", label: "Porcentaje" },
  { id: "valuation", label: "Valoración" },
  { id: "cost", label: "Costo" },
  { id: "scope", label: "Alcance" }
];

export const STYLE_ATTRIBUTES_SPANISH = [
  { id: "Color de Pleca", label: "Color de Pleca" },
  { id: "Título sobre la Pleca", label: "Título sobre la Pleca" },
  { id: "Título de la nota", label: "Título de la nota" },
  { id: "Sintesis", label: "Síntesis" },
  { id: "Testigos", label: "Testigos" },
  { id: "Imagen", label: "Imagen" },
  { id: "Título de Imagen", label: "Título de Imagen" },
  { id: "Línea Divisoria", label: "Línea Divisoria" },
  { id: "Gráfico de Barras", label: "Gráfico de Barras" },
  { id: "Porcentaje", label: "Porcentaje" },
  { id: "Valoración", label: "Valoración" },
  { id: "Costo", label: "Costo" },
  { id: "Alcance", label: "Alcance" }
];

export const AVAILABLE_FONTS = [
  { value: "Open Sans", label: "Open Sans" },
  { value: "Arial Narrow", label: "Arial Narrow" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Roboto", label: "Roboto" },
  { value: "Noto Sans", label: "Noto Sans" },
  { value: "Cabin", label: "Cabin"},
  { value: "Arial", label: "Arial" },
  { value: "Calibri", label: "Calibri"},
  { value: "Cambria", label: "Cambria"},
  { value: "Aptos Display", label: "Aptos Display"},
  { value: "Aptos", label: "Aptos"},
  { value: "Gotham", label: "Gotham"},
];

export const AVAILABLE_POSITIONS = [
  { value: "left", label: "Izquierda" },
  { value: "center", label: "Centro" },
  { value: "right", label: "Derecha" },
  { value: "justify", label: "Justificado" }
];
export const POSITIONS = [
  { value: "left",   label: "Izquierda" },
  { value: "center", label: "Centro" },
  { value: "right",  label: "Derecha" },
];